<template>
  <div>
    <a-table :columns="columns" :data-source="apps" :pagination="false" size="small">
      <template v-slot:name:title>
        <a>{{ title }}</a>
      </template>
    </a-table>
  </div>
</template>

<script>
export default {
  name: 'basicTable',
  data() {
    return {
      apps: [],
      columns: [
        {
          key: 0,
          title: 'Name',
          dataIndex: 'title',
          key: 'title',
        },
        {
          title: 'Price',
          dataIndex: 'price',
          key: 'price',
        },
        {
          title: 'Install Count',
          dataIndex: 'install_count',
          key: 'install_count',
        },
        ,
        {
          title: 'Update Date',
          dataIndex: 'update_date',
          key: 'update_date',
        },
        {
          title: 'Create Date',
          dataIndex: 'create_date',
          key: 'create_date',
        },
        {
          title: 'Actions',
          dataIndex: 'action',
          key: 'action',
        },
      ],
    };
  },
  created() {
    this.$appAxios.post(this.$endpoints.app_get).then(resp => {
      if (resp.data.status) {
        var appss = resp.data.data;
        var _this = this;
        appss.forEach(function(item, index) {
          _this.apps.push({
            key: item.id,
            title: item.title,
            price: item.price,
            install_count: item.install_count,
            update_date: item.update_date,
            create_date: item.create_date,
            action: <a-button type="primary">Detail</a-button>,
          });
        });
      }
    });
  },
};
</script>
